import { SpinnerComponent } from './components/spinner/spinner.component';
import { NgModule} from '@angular/core';

@NgModule ({

    declarations: [
        SpinnerComponent        
    ],
    exports: [
        SpinnerComponent
    ]

})

export class SpinnerModule { }